import React from 'react';
import { Title, Badge, Text, Container, SimpleGrid, Group } from '@mantine/core';

import { EventCard } from '../components/ui';

interface Event {
  id: number;
  name: string;
  slug: string;
  event_start_date: string;
  event_end_date: string;
  description: string;
  event_type_ids: number[];
  venue_id: number;
  image_url?: string;
  discarded_at?: string;
  event_types: any[]; // Adjust type as needed
  venue_name: string;
  address: string;
  [key: string]: any;
}

interface DiscardedItemsProps {
  discardedEvents: Event[];
}

const DiscardedItems: React.FC<DiscardedItemsProps> = ({ discardedEvents }) => {
  return (
    <Container className="discarded-items-page" size="xl" mb="4rem">
      <Group justify="flex-start" mt={40} mb={40}>
        <Title order={1} className="rubik-header" style={{ textAlign: 'center' }}>
          Deleted Items
        </Title>
        <Badge color="red" variant="filled" size="lg" className="ml-2">
          {discardedEvents.length}
        </Badge>
      </Group>

      <Title order={3} c="white" className="poppins">
        Deleted Events
      </Title>

      {discardedEvents.length > 0 ? (
        <SimpleGrid cols={{ base: 2, sm: 2, md: 4 }} spacing="md" mt="md">
          {discardedEvents.map((event) => (
            <EventCard
              key={event.id}
              event={event}
              onCardClick={() => {
                window.location.href = `/events/${event.slug}`;
              }}
            />
          ))}
        </SimpleGrid>
      ) : (
        <Text mt="md">No deleted events.</Text>
      )}
    </Container>
  );
};

export default DiscardedItems;
